import { System } from "yage/components/System";
import { Component, Schema, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { HealthSchema } from ".";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { ChildSchema } from "yage/schemas/entity/Child";
import { registerSystem } from "yage/components/ComponentRegistry";
import { ComponentCategory } from "yage/constants/enums";
import { SpeedEnhancerSchema } from "../enhancers/SpeedEnhancer";

@Component("SpeedCap")
export class SpeedCapSchema extends Schema {
  @type("number")
  speedCap: number;
}

class SpeedCapSystem implements System {
  type = "SpeedCap";
  schema = SpeedCapSchema;
  category = ComponentCategory.PERSIST;

  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "SpeedCap")) {
        gameModel.addComponent(parent, SpeedCapSchema);
      }
    } else {
      const data = gameModel.getTypedUnsafe(entity, SpeedCapSchema);
      if (data.speedCap === undefined) {
        data.speedCap = gameModel.getTyped(entity, SpeedEnhancerSchema)?.speedScale || 0;
      }
    }
  }
}

registerSystem(SpeedCapSystem);
